import React, { createContext, useContext, useEffect } from "react";
import {
  Badge,
  Button,
  DatePicker,
  Layout,
  notification,
  Radio,
  Skeleton,
} from "antd";
import { CommandBar, SearchBox, Tooltip } from "@fluentui/react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import RequestStore from "../approvals/store/requeststore";
import MainStore from "../../home/store/mainStore";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { NoRequest } from "./NoRequest";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import { toAntPickerDate } from "../../../Utility/modules/datePicker";
import { RequestGrid } from "./RequestGrid";
import { NaocDailyProductionDetail } from "./naoc/NaocDailyProductionDetail";
import { CancellationDialog } from "./CancellationDialog";
import { RefreshCcw, XCircle } from "react-feather";
import { EbendoDailyProductionDetail } from "./ebendo/EbendoDailyProductionDetail";
import { QuaiboDailyproductionDetails } from "./quaibo/QuaiboDailyproductionDetails";
const { Content } = Layout;
const mainStorectx = createContext(MainStore);
const requestStoreCtx = createContext(RequestStore);
export const RequestBaseView = observer(() => {
  const requestStore = useContext(requestStoreCtx);
  const mainStore = useContext(mainStorectx);

  const loadMyRequest = async (statusId) => {
    try {
      const requestorId = getCurrentUser()?.id;
      const year = requestStore.productionYear;
      const assetId = mainStore.assetContextId;
      await requestStore.loadRequest(requestorId, year, assetId, statusId);
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    }
  };
  useEffect(() => {
    async function loadRequest() {
      try {
        await loadMyRequest(1);
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadRequest();
  }, []);
  const dateFormat = "YYYY";
  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #cddc39",
      }}
    >
      <Content>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <SubPageHeaderTitle
                title={
                  <>
                    <span>
                      {mainStore.assetContextName} Production Entry Sign-Off
                      Requests &nbsp;
                    </span>
                    <span style={{ color: "gray", fontSize: "14px" }}>
                      | {requestStore.status}
                    </span>
                    <span style={{ color: "gray", fontSize: "14px" }}> | </span>{" "}
                    <Badge count={requestStore.myRequests.size} />
                  </>
                }
              ></SubPageHeaderTitle>
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <CommandBar
                items={[
                  {
                    key: "refresh",
                    text: "Refresh",
                    onRenderIcon: () => <RefreshCcw className="qicon" />,
                    onClick: async () => {
                      requestStore.productionYear = moment().year();
                      await loadMyRequest(requestStore.statusId);
                    },
                  },
                  {
                    key: "cancel",
                    text: "Cancel Request",
                    onRenderIcon: () => <XCircle className="qicon" />,
                    disabled: requestStore.selReqItem?.approvalStatus !== 1,
                    onClick: () => {
                      requestStore.showCancellationDialog = true;
                    },
                  },
                  {
                    key: "search",
                    onRender: () => (
                      <Tooltip title="smart quick search on the requests data displayed">
                        <SearchBox
                          placeholder="Search"
                          styles={{
                            root: {
                              width: "100%",
                              borderBottomColor: "#CBD5E0",
                            },
                          }}
                          underlined={true}
                          onChange={(ev, searchTerms) => {
                            requestStore.reqGrid.api.setQuickFilter(
                              searchTerms
                            );
                            // const filterValue = grid.current.api.filterManager.quickFilter;
                          }}
                        ></SearchBox>
                      </Tooltip>
                    ),
                  },
                  {
                    key: "labe",
                    onRender: () => (
                      <div
                        style={{
                          marginRight: "5px",
                          marginLeft: "10px",
                          paddingTop: "12px",
                        }}
                      >
                        Production Year:{" "}
                      </div>
                    ),
                  },
                  {
                    key: "",
                    onRender: () => (
                      <DatePicker
                        size="small"
                        placeholder="select production year"
                        style={{ width: "200px" }}
                        picker="year"
                        value={requestStore.selDate}
                        defaultValue={toAntPickerDate(new Date())}
                        format={dateFormat}
                        onChange={async (date, val) => {
                          try {
                            requestStore.productionYear = Number(val);

                            await loadMyRequest(requestStore.statusId);
                          } catch (error) {
                            notification.error({
                              message: "SPARS Feedback",
                              description: error.message,
                            });
                          }
                        }}
                      />
                    ),
                  },
                ]}
                farItems={[
                  {
                    key: "labe",
                    onRender: () => (
                      <div style={{ marginRight: "5px" }}>Display: </div>
                    ),
                  },

                  {
                    key: "ggf",
                    onRender: () => (
                      <Radio.Group
                        defaultValue={requestStore.statusId}
                        size="small"
                        buttonStyle="solid"
                        onChange={async ({ target }) => {
                          try {
                            requestStore.statusId = target.value;
                            await loadMyRequest(requestStore.statusId);
                            const status = [
                              "All Request(s)",
                              "Awaiting Approval Request(s)",
                              "Approved Request(s)",
                              "Declined Request(s)",
                            ];
                            requestStore.status = status[target.value];
                          } catch (error) {
                            notification.error({
                              message: "SPARS Feedback",
                              description: error.message,
                            });
                          }

                          //console.log('change',target.value)
                          //requestStore.reqGrid.api.setQuickFilter(target.value);
                        }}
                      >
                        <Radio.Button value={0}>All Requests</Radio.Button>
                        <Radio.Button value={1}>Awaiting Approval</Radio.Button>
                        <Radio.Button value={2}>Approved Requests</Radio.Button>
                        <Radio.Button value={3}>Declined Requests</Radio.Button>
                      </Radio.Group>
                    ),
                  },
                ]}
              />
            </div>
          </div>
        </div>
        {requestStore.isLoading ? (
          <>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </>
        ) : (
          <>
            {requestStore.myRequests.size > 0 ? (
              <RequestGrid />
            ) : (
              <NoRequest
                asset={mainStore.assetContextName}
                status={requestStore.status}
                year={requestStore.productionYear}
              />
            )}
          </>
        )}
        <NaocDailyProductionDetail />
        <CancellationDialog />
        <EbendoDailyProductionDetail />
        <QuaiboDailyproductionDetails />
      </Content>
    </Layout>
  );
});

